import {isEmpty} from "../../../../../_helpers/commonFunctions";
import {Button, Col, Modal, Row} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import moment from "moment";

const PrimerPosLogsModal = ({show, setShow}) => {
    const selectedPos = useSelector((state) => state.CLIENTS_DATA.selectedPrimerPos);
    const [logs, setLogs] = useState([]);

    useEffect(() => {
        if(show && !isEmpty(selectedPos)){
            const mergedArray = [...selectedPos?.generalLogs, ...selectedPos?.contractLogs, ...selectedPos?.deviceLogs, ...selectedPos?.acsVoucherLogs];
            const sortedArray = mergedArray.sort((a, b) => new Date(b.date) - new Date(a.date));
            setLogs(sortedArray);
        } else {
            setLogs([]);
        }
    }, [show]);

    return (
        <Modal backdrop={"static"} className="themeModalMedium" show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>Αρχείο Καταγραφής Ενεργειών Συσκευής</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row style={{overflowX: "auto"}}>
                    <Col md={12}>
                        <table className={"simpleClassicTable clientMovementsReportTable mb-2"} style={{width: "100%", tableLayout: "auto", wordBreak: "normal"}}>
                            <colgroup>
                                <col span={1} style={{width: "20%"}}></col>
                                <col span={1} style={{width: "20%"}}></col>
                                <col span={1} style={{width: "60%"}}></col>
                            </colgroup>
                            <thead>
                            <tr>
                                <th style={{border: "1px solid gray"}}>Ημερομηνία</th>
                                <th style={{border: "1px solid gray"}}>Χρήστης</th>
                                <th style={{border: "1px solid gray"}}>Ενέργεια</th>
                            </tr>
                            </thead>
                            <tbody>
                            {logs?.map((row, idx) => (
                                <tr key={`classTable-${idx}`} style={{cursor: "pointer", height: "35px"}}>
                                    <td style={{border: "1px solid gray"}}>{moment(row["date"]).format("DD/MM/YYYY HH:mm:ss")}</td>
                                    <td style={{border: "1px solid gray"}}>{row["user"]}</td>
                                    <td style={{border: "1px solid gray"}}>{row["description"]}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" onClick={() => setShow(false)}>Κλείσιμο</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default PrimerPosLogsModal;